/* import __COLOCATED_TEMPLATE__ from './truncated-text.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  text?: string | null;
  truncatedText?: string;
  isTruncated: boolean;
  testId: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    content: [];
    truncated: [];
  };
  Element: HTMLSpanElement;
}

const TruncatedText = templateOnlyComponent<Signature>();
export default TruncatedText;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::TruncatedText': typeof TruncatedText;
    'inbox2/conversation-stream/event-parts/truncated-text': typeof TruncatedText;
  }
}
